export default "__VITE_ASSET__7f98093e__"